<template>
  <div class="column content-box product-list">
    <woot-modal-header
      :header-title="$t('PRODUCT.MODAL.HEADER')"
      :header-content="$t('PRODUCT.MODAL.DESC')"
    />
    <loading-state
      v-if="iframeLoading"
      :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
      class="product-frame_loading-container"
    />
    <iframe
      id="dashboard-app--frame-product"
      src="https://mt.unikcore.vn/cdp/indexproduct?contentOnly=true"
      @load="() => onProductFrameLoad()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoadingState from 'dashboard/components/widgets/LoadingState';
export default {
  components: {
    LoadingState,
  },

  props: {
    config: {
      type: Array,
      default: () => [],
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      iframeLoading: true,
    };
  },

  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    dashboardAppContext() {
      return {
        conversation: this.currentChat,
        contact: this.$store.getters['contacts/getContact'](this.contactId),
        currentAgent: this.currentAgent,
      };
    },
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
  },

  mounted() {
    window.onmessage = e => {
      if (
        typeof e.data !== 'string' ||
        e.data !== 'chatwoot-dashboard-app:fetch-info'
      ) {
        return;
      }
      this.onProductFrameLoad();
    };
  },
  methods: {
    onProductFrameLoad() {
      const frameElement = document.getElementById(
        'dashboard-app--frame-product'
      );
      const eventData = { event: 'appContext', data: this.dashboardAppContext };
      frameElement.contentWindow.postMessage(JSON.stringify(eventData), '*');
      this.iframeLoading = false;
    },
    onClose() {
      this.$emit('close');
    },
    async sendProduct() {},
  },
};
</script>

<style>
.content-box.product-list {
  height: 100%;
  overflow: hidden;
}

.product-list iframe {
  padding: 2rem 3.2rem;
  width: 100%;
  height: 90%;
  border: 0;
}

.product-frame_loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
